import React from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const PaymentMethodSelected = ({ controlId }) => (
    <Form.Group controlId={controlId}>
        <div className="payment-method-check">
            <div className="payment-method-group p-3">
                <p><FormattedMessage id="cart_credit_cart"/></p>
                <div className="payment-method-cards d-flex">
                    <span className="payment-method-icon maestro rounded"></span>
                    <span className="payment-method-icon mastercard rounded"></span>
                    <span className="payment-method-icon visa rounded"></span>
                    <span className="payment-method-icon visa-electron rounded"></span>
                </div>
            </div>
            <div className="payment-method-service pt-3">
                <div className="payment-method-service-logo revolut"></div>
            </div>
        </div>
    </Form.Group>
);

export default PaymentMethodSelected;
